import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { Organization } from '@/types/organization';

type UpdateTransactionVisibilityArg = {
  hideTransactionsFromNonPolicyParticipants: boolean;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: UpdateTransactionVisibilityArg }
): Promise<Organization> => {
  return await denApi.patch<Organization, UpdateTransactionVisibilityArg>(
    'admin/organization/transaction-visibility',
    arg
  );
};

export function useUpdateTransactionVisibility(
  swrOptions?: SWRMutationConfiguration<
    Organization,
    Error,
    string,
    UpdateTransactionVisibilityArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    Organization,
    Error,
    string,
    UpdateTransactionVisibilityArg
  >('admin/organization/transaction-visibility', fetcher, swrOptions);

  return {
    updateTransactionVisibility: trigger,
    isLoading: isMutating,
    error,
  };
}
